











































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import moment from "moment/moment";
import { MessageCenterMessage } from "@/shared/types";
@Component({})
export default class MessageDetail extends Vue {
  @Prop()
  selectedEmail: MessageCenterMessage;
  @Prop()
  isOpen: boolean;

  formatDate (date: string) {
    return moment(date).format("MM/DD/yyyy hh:mm A");
  }
  closeEmail () {
    this.$emit("onDetailClose");
  }
}
